import reduxStore from "utils/storeFactory";
import { getChapterEntity } from "selectors/chapter/makeGetChapterEntity";
import getActiveSlideIndex from "selectors/chapter/slideshow/getActiveSlideIndex";

export default function getCurrentVideoId(props) {
  const { playbackState, chapterId } = props;

  let result = null;

  const reduxState = reduxStore.getState();
  const isSingleVideoPlayer = reduxState.playerOptions.singleVideoPlayer;
  const chapterEntity = getChapterEntity(reduxState, { chapterId });
  if (!chapterEntity) {
    throw new Error("calling getMediaId with no chapterEntity");
  }
  if (isSingleVideoPlayer) {
    result = chapterEntity.video;
  } else if (chapterEntity.type === "slideshow") {
    const activeSlideIndex = getActiveSlideIndex(reduxState, { chapterId });
    result = chapterEntity.slides[activeSlideIndex].video;
  } else if (chapterEntity.type === "video") {
    result = chapterEntity.video;
  } else if (chapterEntity.type === "interview") {
    const question = playbackState.currentQuestion;
    if (!question) {
      result = question.video;
    }
  } else if (chapterEntity.type === "pathfinder") {
    if (chapterEntity.introductionVideo) {
      result = chapterEntity.introductionVideo.video;
    } else {
      result = chapterEntity.loopVideo.video;
    }
  }

  return result;
}
